import { render } from "./Strategy.vue?vue&type=template&id=ab08eb2c&scoped=true"
import script from "./Strategy.vue?vue&type=script&lang=js"
export * from "./Strategy.vue?vue&type=script&lang=js"

import "./Strategy.vue?vue&type=style&index=0&id=ab08eb2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab08eb2c"]])

export default __exports__